(function ($) {
    let breadcrumbs = document.querySelector('#system-breadcrumb');
    if (breadcrumbs) {
        let crumbs = breadcrumbs.querySelectorAll('li');
        let minWidth = 1300;
        let trucMax = 10;
        if (crumbs.length > 3) {
            let origCrumbs = breadcrumbs.innerHTML;
            let crumbString = crumbs.item(crumbs.length - 2).getElementsByTagName('a')[0].innerHTML;
            let cleanCrumb = crumbString.replace(/(\r\n|\n|\r)/gm, '').trim();
            if (cleanCrumb.length > trucMax && window.innerWidth > minWidth) {
                let truncCrumb = cleanCrumb.substring(0, trucMax);
                crumbs.item(crumbs.length - 2).getElementsByTagName('a')[0].innerHTML = truncCrumb + '...';
            }
            let newCrumbs = crumbs.item(0).outerHTML + '<li><a class="expand-breadcrumbs" aria-label="expand breadcrumbs" href="#">...</a></li>' + crumbs.item(crumbs.length - 2).outerHTML + crumbs.item(crumbs.length - 1).outerHTML;
            breadcrumbs.innerHTML = newCrumbs;
            document.querySelector('.expand-breadcrumbs').addEventListener("click", function (e) {
                e.preventDefault();
                breadcrumbs.innerHTML = origCrumbs;
            });
        }
    }
}(jQuery));
